import React, { useState } from 'react';
import styles from "./styles.module.scss";
import { ManageJobsStats, TableSection } from "components";
import { CVAnalysisTableSection } from "components/manage-jobs/cv-analysis-table-section";
import { useSearchParams } from "react-router-dom";

type ManageJobsTab = "assessments" | "cv-analysis";

const ManageJobsUI = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = (searchParams.get("tab") as ManageJobsTab) || "assessments";
  const [activeTab, setActiveTab] = useState<ManageJobsTab>(tabFromUrl);

  const handleTabChange = (tab: ManageJobsTab) => {
    setActiveTab(tab);
    const params = new URLSearchParams(searchParams);
    params.set("tab", tab);
    // Reset filter and page when switching tabs
    params.delete("filter");
    params.delete("page");
    params.delete("search");
    setSearchParams(params, { replace: true });
  };

  return (
    <div className={styles.container}>
      <section className={`md:px-9 px-4 md:py-5 py-6 ${styles.mainSection}`}>
        <ManageJobsStats />

        {/* Tab Navigation */}
        <div className="flex gap-0 border-b border-gray-200 mt-6 mb-4 w-fit">
          <button
            onClick={() => handleTabChange("assessments")}
            className={`px-6 py-3 text-lg font-medium transition-colors relative ${
              activeTab === "assessments"
                ? "text-[#012169] border-b-2 border-[#012169] -mb-[1px]"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            Assessments
          </button>
          <button
            onClick={() => handleTabChange("cv-analysis")}
            className={`px-6 py-3 text-lg font-medium transition-colors relative ${
              activeTab === "cv-analysis"
                ? "text-[#605BFF] border-b-2 border-[#605BFF] -mb-[1px]"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            CV Analysis
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === "assessments" ? (
          <TableSection />
        ) : (
          <CVAnalysisTableSection />
        )}
      </section>
    </div>
  )
}

export { ManageJobsUI }
